import { render } from "./bookmark_timeline.vue?vue&type=template&id=2b9c8ba0"
import script from "./bookmark_timeline.js?vue&type=script&lang=js"
export * from "./bookmark_timeline.js?vue&type=script&lang=js"

import exportComponent from "/Users/lainsoykaf/repos/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__